'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return Array.prototype.flat || implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.flat/polyfill.js
// module id = 382
// module chunks = 4